import { useCallback } from "react";
import { useServerSdk } from "../../../RootNavigator/services/ServerSdk";
import ProjectInquiryStatus from "../inquiry/ProjectInquiryStatus";
import { Analysis } from "@hpo/client/models/Analysis";
import { ProjectInstructor } from "@hpo/client/models/Project";
import { useAssistance } from "@hpo/client/navigators/RootNavigator/services/Assistance";
import List, { ListItem } from "@hpo/client/utilities/List";
import { canProjectHaveInquiry } from "@hpo/client/utilities/helpers/ProjectHelper";

type ProjectTabDescriptionProps = {
  project: ProjectInstructor;
  onReload: () => unknown;
};

export default function ProjectTabDescription(
  props: ProjectTabDescriptionProps,
) {
  const { project, onReload } = props;

  const serverSdk = useServerSdk();
  const assistance = useAssistance();
  assistance.useVisibilityDecision(true);

  const saveAnalysis = useCallback(
    async (resourceId: string, fields: Analysis) => {
      await serverSdk.saveAnalysis(resourceId, fields);
      await onReload();
    },
    [onReload],
  );

  return (
    <List
      data={project.descriptions}
      renderItem={(description) => {
        const commentButton = (
          <ProjectInquiryStatus
            analysis={description.analysis}
            onChange={(a) => saveAnalysis(description.id, a)}
            readonly={!canProjectHaveInquiry(project)}
          />
        );

        return (
          <ListItem
            label={description.label}
            help={description.value}
            right={commentButton}
          />
        );
      }}
    />
  );
}
